<template>
  <c-row>
    <c-col col="6">
      <c-card>
        <c-card-body>
          <table class="table table-bordered table-stripped">
            <thead>
              <tr>
                <th>No</th>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, k) in data.data" :key="k">
                <td>{{k + 1}}</td>
                <td>{{ v.name }}</td>
              </tr>
            </tbody>
          </table>
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPAUTH } from '../../lib/httplib'
export default {
  name: "CustomerList",
  components: {
  },
  data () {
    return {
      data: {}
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      HTTPAUTH.get("/api/v1/customer-type").then(res => {
        this.data = res.data
      })
    }
  }
}
</script>
